import React, { useEffect, useState } from "react";
import LeadsTable from "../Table/LeadsTable";
import LeadsFilterSearch from "./LeadsFilterSearch";

import { Alert, AlertTitle, Grid } from "@mui/material";
import LeadersSearchHeader from "./LeadersSearchHeader";
import {
  deleteLeadAction,
  leadFindAction,
  recalledLeadFilterAction,
  recalledLeadFindAction,
  recalledLeadFindWithoutPaginationAction
} from "../../actions/leadActions/leadActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { findUserAction } from "../../actions/adminAuthAction";
import DownloadExcel from "../extraComponents/DownloadExcel";
import { SUCCESS_TRUE_MSG_ERR } from "../../constants/roleManagmentConstant";
import { successTrueMsgAction } from "../../actions/globalAction";
import DownloadPdf from "../extraComponents/DownloadPdf";
import axios from "axios";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";
import Loader from "../LoaderComponent/Loader";

function RecalledLeads(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [data, setData] = useState([]);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagination] = useState(false)
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [searchValue, setSearchValue] = useState('');
  const [filterPagination, setFilterPagination] = useState(false)
  const [currentFilterData, setCurrentFilterData] = useState(null);

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // let { leadFindLoading, leadFindSuccess } = useSelector((state) => {
  //   return state.leadFind;
  // });

  const { recalledLeadFindLoading, recalledLeadFindSuccess } = useSelector((state) => state.recalledLeadFind)

  let { leadAddSuccess, leadAdderror } = useSelector((state) => {
    return state.leadAdd;
  });

  let { leadDeleteSuccess } = useSelector((state) => {
    return state.deleteLead;
  });

  let { leadOwnerSuccess } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  let { loginFindSuccess } = useSelector((state) => {
    return state.findUser;
  });

  let { successAlertMsgSuccess, successAlertMsgErr } = useSelector((state) => {
    return state.successTrueMsg;
  });

  const { recalledLeadWithoutPaginationSuccess } = useSelector((state) => state.recalledLeadWithoutPagination)

  const { recalledLeadFilterSuccess } = useSelector((state) => state.recalledLeadFilter)
  
  useEffect(() => {
    dispatch(findUserAction());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(
  //     leadFindAction(pagiantionEntry, paginationPageNumber, "recalledLeads")
  //   );
  // }, [
  //   dispatch,
  //   leadAddSuccess,
  //   leadDeleteSuccess,
  //   leadOwnerSuccess,
  //   pagiantionEntry,
  //   paginationPageNumber
  // ]);

  useEffect(() => {
    if (!searchPagination && !filterPagination || leadOwnerSuccess) {
      dispatch(recalledLeadFindAction(pagiantionEntry, paginationPageNumber))
      dispatch(recalledLeadFindWithoutPaginationAction())
    }
  }, [
    dispatch,
    leadAddSuccess,
    leadDeleteSuccess,
    leadOwnerSuccess,
    pagiantionEntry,
    paginationPageNumber,
    searchPagination,
    filterPagination
  ])

  useEffect(() => {
    if (recalledLeadFindSuccess || reset) {
      setLeadData(recalledLeadFindSuccess?.allLeads);
    }
  }, [recalledLeadFindSuccess, reset])

  useEffect(() => {
    if(recalledLeadFilterSuccess || reset) {
      setFilterPagination(true);
      setPaginationPageNumber(1);
      setLeadData(recalledLeadFilterSuccess?.allLeads)
    }
  }, [recalledLeadFilterSuccess, reset])

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn])

  useEffect(() => {
    if (leadAddSuccess && successAlertMsgSuccess) {
      Swal.fire("Added!", "Lead created successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
    if (leadAdderror && successAlertMsgErr) {
      Swal.fire("Error!", leadAdderror, "error");
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [
    leadAddSuccess,
    leadAdderror,
    successAlertMsgSuccess,
    successAlertMsgErr
  ]);

  useEffect(() => {
    setData(
      leadData
        ?.map((lead, index) => {
          return {
            id: lead.id,
            sl: index + 1,
            name: lead?.firstName,
            email: lead.email,
            countryId: lead.countryId,
            phone: lead.mobileNumber,
            whatsappNumber: lead.whatsappNumber,
            preferredCountry: lead.preferredCountryId,
            leadSource: lead.leadSource,
            leadOwner: lead.leadOwnerName ? lead.leadOwnerName : "-",
            status: lead.status,
            priority: lead.priority ? lead.priority : "-",
            leadCity: lead.location,
            branchId: lead.branchId,
            leadBranch: lead?.branch_master?.branchName
              ? lead?.branch_master?.branchName
              : "-",
            leadCounsilor:
              loginFindSuccess?.role?.roleName !== "counsellor"
                ? lead?.counsilorID
                  ? lead?.counsilorID
                  : "-"
                : null,
            leadTeleCaller:
              loginFindSuccess?.role?.roleName !== "tele caller" ||
                loginFindSuccess?.isTeleCallerTeamLead == true ||
                loginFindSuccess?.isTelecallerManager == true
                ? lead?.teleCallerId
                  ? lead?.teleCallerId
                  : "-"
                : null
          };

          return null;
        })
        .filter(Boolean)
    );
  }, [leadData]);

  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim();
      setSearchValue(newSearchValue);

      if (newSearchValue === "") {
        setSearchPagination(false);
        setLeadData(recalledLeadFindSuccess?.allLeads);
        return;
      }

      setPaginationPageNumber(1)

    } catch (error) {
      console.error(error);
    }
  }

  const searchHandleChange = async (e) => {
    try {
      const newSearchValue = e.target.value.trim()

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(recalledLeadFindAction(pagiantionEntry, paginationPageNumber));
        return;
      }

      setSearchValue(newSearchValue);
      setSearchPagination(true);
      setFilterPagination(false);

      fetchSearchResults(newSearchValue, paginationPageNumber);

    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNum) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/lead/searchrecalledlead?q=${searchValue}
        &limit=${pagiantionEntry}&pagenumber=${paginationPageNumber}&id=${UserId}`, config)

      setSearchPaginationCount(data?.totalCount);
      setLeadData(data?.payload);

    } catch (error) {
      console.error(error);
    }
  };

  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);

  // material Table
  const columns = [
    {
      title: "Sl no",
      field: "sl"
    },
    {
      title: "Name",
      field: "name",
      // hidden: showNameColumn
    },
    {
      title: "Email",
      field: "email",
      // hidden: showEmailColumn
    },
    {
      title: "Phone     ",
      field: "phone",
      // hidden: showPhoneColumn
    },

    {
      title: "What's App Number",
      field: "whatsappNumber",
      // hidden: showWhatsAppNumColumn
    },
    {
      title: "Preferred Country",
      field: "preferredCountry",
      // hidden: showPrefferedColumn
    },
    {
      title: "Lead Source",
      field: "leadSource",
      // hidden: showLeadSourceColumn
    },
    {
      title:
        loginFindSuccess && loginFindSuccess?.role?.roleName == "branch manager"
          ? "Counsilor"
          : "Lead Owner",
      field: "leadOwner",
      // hidden: showLeadOwnerColumn
    },
    {
      title: "Lead Branch",
      field: "leadBranch",
      // hidden: showLeadBranchColumn
    },
    {
      title: "Status",
      field: "status",
      // hidden: showStatusColumn
    },
    {
      title: "Priority",
      field: "priority",
      // hidden: showPriorityColumn
    },
    {
      title: "Lead Place",
      field: "leadCity",
      // hidden: showLeadPlaceColumn
    },
    {
      title:
        loginFindSuccess?.role == null ||
          loginFindSuccess?.isManager ||
          loginFindSuccess?.role?.roleName !== "tele caller" ||
          loginFindSuccess?.isTeleCallerTeamLead == true ||
          loginFindSuccess?.isTelecallerManager == true
          ? "TeleCaller"
          : null,
      field: "TeleCaller",
      // hidden: showTelecallerColumn
    },
    {
      title:
        loginFindSuccess?.role == null ||
          loginFindSuccess?.isManager ||
          loginFindSuccess?.role?.roleName !== "counsellor"
          ? "Counsilor"
          : null,
      field: "Counsilor",
      // hidden: showCounsilorColumn
    },
    {
      title: "",
      field: "action",
      filtering: false
    }
  ];

  const excelDownloadClick = () => {
    DownloadExcel(columns, data, "dead_Management");
  };

  const pdfDownloadClick = () => {
    DownloadPdf(columns, data, "dead_Management", "Recalled Lead Details");
  };

  const toggleNameColumn = (status, columnName) => {
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  const LeadFilterFunction = (filterData) => {
    try {
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      setFilterPagination(true);
      setPaginationPageNumber(1);
      dispatch(recalledLeadFilterAction(filterData, pagiantionEntry, 1))
    } catch (error) {
      console.error(error);
    }
  }

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(recalledLeadFindAction(pagiantionEntry, 1));
  };

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(recalledLeadFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(recalledLeadFindAction(value, 1));
    }
  }

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };

  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(recalledLeadFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(recalledLeadFindAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (!hasPrivilege("recalled") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <LeadersSearchHeader
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        component="recalled"
        subMenu="recalled"
        column={columns}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      {/* <div style={{display:"flex",justifyContent:"space-evenly", width:"auto"}}> */}
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="lead"
            data={recalledLeadWithoutPaginationSuccess?.allLeads}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
            component="recalled"
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
          {recalledLeadFindLoading ? (
            <Loader />
          ) : data?.length === 0 ? (
            <TableNoItemComponent />
          ) : (
            <LeadsTable
              toggle={props.toggle}
              reset={reset}
              setIdsFunction={setIdsFunction}
              data={data}
              columns={columnVisibilityData.length > 0 ? columnVisibilityData : columns}
              selectBoxIdPassHandler={selectBoxIdPassHandler}
              isExistCounsilor={loginFindSuccess}
              component="recalled"
              pagiantionEntry={pagiantionEntry}
              paginationPageNumber={paginationPageNumber}
              subMenu="recalled"
              mainMenu="Leads"
              paginationDataFetching={paginationDataFetching}
              totalLeadCount={
                searchPagination ? searchPaginationCount : 
                filterPagination ? recalledLeadFilterSuccess?.totalCount :
                recalledLeadFindSuccess?.totalCount
              }
              viewedColumn={viewedColumn}
              searchPagination={searchPagination}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default RecalledLeads;
